import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'

import {
  PATCH_ORDER,
  UPDATE_USER_NOTES,
  patchOrderSucceeded,
  patchOrderFailed,
  updateUserNotesSucceeded,
  updateUserNotesFailed,
} from '../../actions/orders/patch'

import Remote from '../../remote'

function* patchOrderRequestSaga(orderId, attributes) {
  yield call(Remote.updateOrder, orderId, attributes)
}

function* patchOrderSaga(params = {}) {
  const { orderId, attributes } = params?.payload ?? {}

  try {
    const result = yield patchOrderRequestSaga(orderId, attributes)
    yield put(patchOrderSucceeded(result))
  } catch(err) {
    yield put(patchOrderFailed(err))
  }
}

export function* watchPatchOrderSaga() {
  yield takeEvery(PATCH_ORDER, patchOrderSaga)
}

export function* updateUserNotesSaga(params = {}) {
  const { orderId, userNotes } = params?.payload ?? {}

  try {
    const result = yield patchOrderRequestSaga(orderId, { userNotes })
    yield put(updateUserNotesSucceeded(result))
  } catch (err) {
    yield put(updateUserNotesFailed(err))
  }
}

export function* watchUpdateUserNotesSaga() {
  yield takeLatest(UPDATE_USER_NOTES, updateUserNotesSaga)
}
